import { logUsage } from 'owa-analytics';
import { getStore } from '../store/store';
import { ValidatedAttachmentType } from '../store/schema/ValidatedAttachmentType';

export async function logBlockingDialogDataPoint(composeId: string, forceSend: boolean) {
    const store = getStore();
    const telemetryData = store.telemetryDataForFailedValidation.get(composeId);
    const timeDialogOpen =
        telemetryData?.[ValidatedAttachmentType.SharingIssue]?.timeBlockingDialogOpen;

    if (timeDialogOpen) {
        const timeDialogClose = new Date().getTime();
        const timeSpan: number = timeDialogClose - timeDialogOpen;

        logUsage(
            'SharingIssueBlockingDialog',
            {
                userAction: forceSend
                    ? 'SendClickOnFailedValidation'
                    : 'DoNotSendClickOnFailedValidation',
            },
            {
                cosmosOnlyData: JSON.stringify({
                    timeSpan: timeSpan,
                }),
            }
        );
    }
}
